import React, {Component} from 'react';
import {
  // ActivityBar,
  // ActivityBarFill,
  ActivityContainer, BloodPressureContainer,
  BorderBottom,
  BoxHeader,
  ChartBarContainer,
  // PercentageContainer
} from "./styles";
import PropTypes from "prop-types";
// import { PercentageIcon } from '../../utils/icons';
import { ProgressBar } from '../HealthTabV2/HealthTabUpdated/styles';
// import LazyImage from '../common/LazyImage/LazyImage';
// import { ImageUrl } from '../../utils/constants';

export default class BloodPressure extends Component{

  constructor(props) {
    super(props)
  }
 
  
  render(){
    
    
    const{bloodPressureData, marginRight, isStyle, heading, subHeading,width,margin }= this.props;

    return(
      <BloodPressureContainer marginRight = {marginRight} width={width || "50%"} margin={margin}>
        <BoxHeader>
          <div>
            {/* <LazyImage src={ImageUrl + "/images/CompanyDashBoardV2/blood-pressure.png"}/> */}
            {bloodPressureData?.[0].id === "Diastolic" ? 'Diastolic Blood Pressure' :heading ? heading : 'Systolic Blood Pressure' }
            <span className='sub-heading'>&nbsp;{subHeading}</span>
          </div>
        </BoxHeader>
        <BorderBottom/>
        <ChartBarContainer bloodPressure>
          <div className="sliderAverageContainer">
            <div className="sliderContainer">
              {
                bloodPressureData && bloodPressureData?.map((item, index) => (
                  <div key={index}>
                    <ActivityContainer  color={'#184A61'} isMargin={index === 0 ? "0px" : "40.5px 0px 0px 0px"}>
                      <div className="chartTitle">
                        {item.title}
                      </div>
                      <div className={ isStyle ? "chartSubTitle1" : "chartSubTitle"}>
                        {item.value ? `[${item.value}]` : null}
                      </div>
                      <div className="bar" style={{marginTop:"13px"}}>
                        <ProgressBar
                          height={"16px"}
                          backgroundActive={item.fillColor}
                          background={"#EFEFEF"}
                          width={Number(item.width.replace(/%/g, ''))}
                          paddingRight="0px"
                        >
                          <div className="progress"></div>
                          <div className="percentageValue">
                            {item.width}
                          </div>
                        </ProgressBar>
                      </div>
                      {/* <ActivityBar style={{ display: 'flex', alignItems: 'center' }} barHeight="28px" isRadius="0px" fillColor="rgba(33, 153, 193, 1)" backgroundFill={'rgba(0, 92, 135, 0.05)'}>
                        <ActivityBarFill   isRadius="0px 4px 4px 0px"  isPadding="0px 2px"  width={item.width} fillColor= {item.fillColor}>
                        </ActivityBarFill>
                        <PercentageContainer isMargin={Number(item.width.replace(/%/g, '')) >= 30 ? '0px' : '10px'} left={(item.width)}>
                          {Number(item.width.replace(/%/g, '')) >= 30 ?
                            <div className="icon-container">
                              {PercentageIcon(item.fillColor)}
                              <div style={{ marginLeft: '-38px' }}>{item.width}</div>
                            </div>
                            : item.width}
                        </PercentageContainer>
                      </ActivityBar> */}
                    </ActivityContainer>
                  </div>
                ))
              }
            </div>
          </div>
        </ChartBarContainer>
      </BloodPressureContainer>
    )
  }
}

BloodPressure.propTypes = {
  bloodPressureData: PropTypes.array,
  marginRight : PropTypes.bool,
  isStyle : PropTypes.bool,
  averagePoints: PropTypes.string,
  heading:PropTypes.string,
  subHeading:PropTypes.string,
  width:PropTypes.string,
  margin:PropTypes.string
};